<template>
  <div class="personalMain" v-show="currentInfo && currentInfo.roleCode != 'ASSISTANT'">
    <div class="personalMainHead">
      <PersonalHead
        :showIndex="showIndex"
        :isShowGuide="isShowGuide"
      ></PersonalHead>
    </div>
    <div class="personalMainLeft" v-if="currentInfo && currentInfo.roleCode != 'ASSISTANT'">
      <!-- <div class="textAlign cursorPointer bg">
        <img
          src="./../../assets/images/menu/shrink_icon.png"
          v-show="!isCollapse"
          @click="handelCollapse()"
          alt
          style="display: inline-block"
        />
        <img
          src="./../../assets/images/menu/stretch_icon.png"
          v-show="isCollapse"
          @click="handelCollapse()"
          alt
          style="display: inline-block"
        />
      </div> -->
      <el-menu
        :default-openeds="defaultOpenedsArray"
        :default-active="isShowGuide ? '' : currentUrl"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        @select="handleSelect"
        :router="true"
      >
        <!-- 工作台 -->
        <el-menu-item
          index="/personal/home"
          :class="{ activeColor: currentUrl == '/personal/home' }"
        >
          <img
            class="icon img01"
            src="./../../assets/images/menu/gzt.png"
            alt
          />
          <img
            class="icon img02"
            src="./../../assets/images/menu/gzt_a.png"
            alt
          />
          <span slot="title">工作台</span>
        </el-menu-item>
        <!-- 签约管理-->
        <el-submenu
          index="1"
          :class="[showIndex == 1 ? 'guide' : '']"
          :disabled="showIndex == 1"
          v-if="currentInfo.roleCode"
        >
          <template slot="title">
            <div class="father">
              <img
                class="icon img01"
                src="./../../assets/images/menu/fqfq.png"
                alt
              />
              <img
                class="icon img02"
                src="./../../assets/images/menu/fqfq_a.png"
                alt
              />
              <span>赋强公证申请</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item
              
              class="paddingLefts no-active"
              @click="routerPush('/initiation/single')"
              >
              <!-- index="/personal/sign/home" -->
              
              <!-- <img class="icon img01" src="./../../assets/images/menu/qygl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/qygl_icon_btn_nov.png" alt>  -->
              填写申请
            </el-menu-item>
            <el-menu-item
              class="paddingLefts no-active" @click="toInitiationBatch()"
              >
              <!-- index="/personal/sign/index" -->
              <!-- :class="{
                activeColor:
                  currentUrl == '/personal/sign/index' ||
                  currentUrl == '/personal/sign/signLoanContract',
                activeItem: currentUrl == '/personal/sign/signLoanContract',
              }" -->
              <!-- <img class="icon img01" src="./../../assets/images/menu/fqqy_icon_btn_nor.png" alt> -->
              <!-- <img class="icon img02" src="./../../assets/images/menu/fqqy_icon_btn_nov.png" alt> -->
              批量导入
            </el-menu-item>

            <!-- <el-menu-item class="paddingLefts"
              index="/personal/sign/template"
              :class="{'activeColor':currentUrl=='/personal/sign/template'}"
            >
              <img class="icon img01" src="./../../assets/images/menu/htmb_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/htmb_icon_btn_nov.png" alt>
              合同模版
            </el-menu-item> -->
            <!-- <el-menu-item class="paddingLefts"
              index="/personal/sign/record"
              :class="{'activeColor':currentUrl =='/personal/sign/record'}"
            >
              <img class="icon img01" src="./../../assets/images/menu/htgmjl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/htgmjl_icon_btn_nov.png" alt>
              合同购买记录
            </el-menu-item> -->
          </el-menu-item-group>
        </el-submenu>
        <!--履约管理  -->
        <!--        <el-submenu index="3">-->
        <!--          <template slot="title">-->
        <!--            <div class="father">-->
        <!--              <img class="icon img01" src="./../../assets/images/menu/lygl_icon_btn_nor.png" alt>-->
        <!--              <img class="icon img02" src="./../../assets/images/menu/lygl_icon_btn_nov.png" alt>-->
        <!--              <span>履约管理</span>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--          <el-menu-item-group>-->
        <!--            <el-menu-item class="paddingLefts"-->
        <!--              index="/personal/performance/index"-->
        <!--              :class="{'activeColor':currentUrl =='/personal/performance/index'}"-->
        <!--            >-->
        <!--              &lt;!&ndash; <img class="icon img01" src="./../../assets/images/menu/cjly_icon_btn_nor.png" alt> &ndash;&gt;-->
        <!--              &lt;!&ndash; <img class="icon img02" src="./../../assets/images/menu/cjly_icon_btn_nov.png" alt> &ndash;&gt;-->
        <!--              创建履约任务-->
        <!--            </el-menu-item>-->

        <!--            <el-menu-item class="paddingLefts"-->
        <!--              index="/personal/performance/list"-->
        <!--              :class="{'activeColor':currentUrl =='/personal/performance/list'}"-->
        <!--            >-->
        <!--              &lt;!&ndash; <img class="icon img01" src="./../../assets/images/menu/lvlb_icon_btn_nor.png" alt> &ndash;&gt;-->
        <!--              &lt;!&ndash; <img class="icon img02" src="./../../assets/images/menu/lvlb_icon_btn_nov.png" alt> &ndash;&gt;-->
        <!--              履约列表-->
        <!--            </el-menu-item>-->
        <!--          </el-menu-item-group>-->
        <!--        </el-submenu>-->
        <!-- 签约管理-->
        <el-submenu index="2" :class="[showIndex==1?'guide':'']" :disabled="showIndex==1">
          <template slot="title">
            <div class="father">
              <img
                  class="icon img01"
                  src="./../../assets/images/menu/qyfw.png"
                  alt
              >
              <img
                  class="icon img02"
                  src="./../../assets/images/menu/qyfw_a.png"
                  alt
              >
              <span>签约服务</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item class="paddingLefts"
                          index="/personal/sign/home"
                          :class="{'activeColor':currentUrl =='/personal/sign/home'  ,'activeItem':currentUrl =='/personal/serviceHome/writeProcedure'}"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/qygl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/qygl_icon_btn_nov.png" alt>  -->
              签约管理
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!-- 赋强履约管理  -->
        <el-submenu
          index="3"
          :class="[showIndex == 3 ? 'guide' : '']"
          :disabled="showIndex == 3"
          v-if="currentInfo.roleCode"
        >
          <template slot="title">
            <div class="father">
              <img
                class="icon img01"
                src="./../../assets/images/menu/fqgl.png"
                alt
              />
              <img
                class="icon img02"
                src="./../../assets/images/menu/fqgl_a.png"
                alt
              />
              <span>履约管理</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item
              class="paddingLefts"
              index="/personal/fqPerformance/list"
              :class="{
                activeColor: currentUrl == '/personal/fqPerformance/list',
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/lvlb_icon_btn_nor.png" alt> -->
              <!-- <img class="icon img02" src="./../../assets/images/menu/lvlb_icon_btn_nov.png" alt> -->
              履约列表
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 预警提醒 -->
        <!-- <el-submenu index="4">
          <template slot="title">
            <div class="father">
              <img class="icon img01" src="./../../assets/images/menu/yjtx_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/yjtx_icon_btn_nov.png" alt>
              <span>预警提醒</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item class="paddingLefts"
              index="/personal/warning/add"
              :class="{'activeColor':currentUrl =='/personal/warning/add'}"
            > -->
        <!-- <img class="icon img01" src="./../../assets/images/menu/xzyj_icon_btn_nor.png" alt> -->
        <!-- <img class="icon img02" src="./../../assets/images/menu/xzyj_icon_btn_nov.png" alt> -->
        <!-- 新增预警
      </el-menu-item>
      <el-menu-item class="paddingLefts" index="/personal/warning/index"> -->
        <!-- <img class="icon img01" src="./../../assets/images/menu/yjlb_icon_btn_nor.png" alt> -->
        <!-- <img class="icon img02" src="./../../assets/images/menu/yjlb_icon_btn_nov.png" alt> -->
        <!-- 预警列表
      </el-menu-item>
    </el-menu-item-group>
  </el-submenu> -->
        <!-- 司法服务 -->
        <el-submenu
          index="5"
          :class="[showIndex == 2 ? 'guide' : '']"
          :disabled="showIndex == 2"
          v-if="currentInfo.roleCode"
        >
          <template slot="title">
            <div class="father">
              <img
                class="icon img01"
                src="./../../assets/images/menu/gzfw.png"
                alt
              />
              <img
                class="icon img02"
                src="./../../assets/images/menu/gzfw_a.png"
                alt
              />
              <span>公证服务</span>
            </div>
          </template>
          <el-menu-item-group>
            <!--            <el-menu-item class="paddingLefts"-->
            <!--              index="/personal/serviceHome"-->
            <!--              :class="{'activeColor':notarList.indexOf(currentUrl) !=-1,'activeItem':notarList.indexOf(currentUrl) !=-1}"-->
            <!--            >-->
            <!--              &lt;!&ndash; <img class="icon img01" src="./../../assets/images/menu/sffw_icon_btn_nor.png" alt> &ndash;&gt;-->
            <!--              &lt;!&ndash; <img class="icon img02" src="./../../assets/images/menu/sffw_icon_btn_nov.png" alt> &ndash;&gt;-->
            <!--              我的公证-->
            <!--            </el-menu-item>-->
            <!-- <el-menu-item
              index="/personal/service"
              :class="{'activeColor':currentUrl =='/personal/service'}"
            >
              <img class="icon img01" src="./../../assets/images/menu/sqfw_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/sqfw_icon_btn_nov.png" alt>申请服务
            </el-menu-item> -->
            <el-menu-item
              class="paddingLefts"
              index="/personal/service/loan"
              :class="{
                activeColor:
                  notarList.indexOf(currentUrl) != -1 &&
                  (notaryBusinessId == 2 || notaryBusinessId == 3),
                activeItem:
                  notarList.indexOf(currentUrl) != -1 &&
                  (notaryBusinessId == 2 || notaryBusinessId == 3),
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/sffw_icon_btn_nor.png" alt> -->
              <!-- <img class="icon img02" src="./../../assets/images/menu/sffw_icon_btn_nov.png" alt> -->
              贷款赋强公证
            </el-menu-item>
            <el-menu-item
              class="paddingLefts"
              index="/personal/service/conciliation"
              :class="{
                activeColor:
                  notarList.indexOf(currentUrl) != -1 &&
                  (notaryBusinessId == 7 || notaryBusinessId == 8),
                activeItem:
                  notarList.indexOf(currentUrl) != -1 &&
                  (notaryBusinessId == 7 || notaryBusinessId == 8),
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/sffw_icon_btn_nor.png" alt> -->
              <!-- <img class="icon img02" src="./../../assets/images/menu/sffw_icon_btn_nov.png" alt> -->
              调解赋强公证
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 个人中心 -->
        <el-submenu
          index="6"
          :class="[showIndex == 4 ? 'guide' : '']"
          :disabled="showIndex == 4"
        >
          <template slot="title">
            <div class="father">
              <img
                class="icon img01"
                src="./../../assets/images/menu/grzx.png"
                alt
              />
              <img
                class="icon img02"
                src="./../../assets/images/menu/grzx_a.png"
                alt
              />
              <span>用户中心</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item
              class="paddingLefts"
              index="/personal/users/home"
              :class="{ activeColor: currentUrl == '/personal/users/home' }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/jbxx_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/jbxx_icon_btn_nov.png" alt> -->
              个人中心
            </el-menu-item>
            <el-menu-item
              class="paddingLefts"
              v-if="realNameq"
              index="/personal/users/enterpriseSupplement?flag=2"
              :class="{
                activeColor:
                  currentUrl == '/personal/users/enterpriseSupplement',
                activeItem:
                  currentUrl == '/personal/users/enterpriseSupplement',
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/jbxx_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/jbxx_icon_btn_nov.png" alt> -->
              机构资料补充
            </el-menu-item>
            <el-menu-item
              class="paddingLefts"
              index="/personal/users/cost"
              :class="{ activeColor: currentUrl == '/personal/users/cost' }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/fygl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/fygl_icon_btn_nov.png" alt> -->
              费用管理
            </el-menu-item>
            <el-menu-item
              class="paddingLefts"
              index="/personal/users/signature"
              :class="{
                activeColor: currentUrl == '/personal/users/signature',
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/qzgl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/qzgl_icon_btn_nov.png" alt> -->
              签章管理
            </el-menu-item>
            <!-- <el-menu-item class="paddingLefts"
                          index="/personal/users/authorization"
                          :class="{'activeColor':currentUrl =='/personal/users/authorization'}"
            > -->
            <!-- <img class="icon img01" src="./../../assets/images/menu/sqgl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/sqgl_icon_btn_nov.png" alt> -->
            <!-- 授权管理
            </el-menu-item> -->
            <el-menu-item
              class="paddingLefts"
              index="/personal/users/signatory"
              :class="{
                activeColor: currentUrl == '/personal/users/signatory',
              }"
            >
              <!-- <img class="icon img01" src="./../../assets/images/menu/qyfgl_icon_btn_nor.png" alt>
              <img class="icon img02" src="./../../assets/images/menu/qyfgl_icon_btn_nov.png" alt> -->
              签约方管理
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 组织管理 -->
        <!-- <el-submenu index="7">
          <template slot="title">
            <div class="father">
              <img class="icon img01" src="./../../assets/images/menu/servicelist_nor_icon.png" alt>
              <img
                  class="icon img02"
                  src="./../../assets/images/menu/servicelist_hov_pre_icon.png"
                  alt
              >
              <span>组织管理</span>
            </div>
          </template>
          <el-menu-item-group>
            <el-menu-item class="paddingLefts"
                          index="/personal/organization/employee"
                          :class="{'activeColor':notarList.indexOf(currentUrl) !=-1,'activeItem':notarList.indexOf(currentUrl) !=-1}"
            >
              员工管理
            </el-menu-item>
          </el-menu-item-group> -->
        <!-- </el-submenu> -->
      </el-menu>
    </div>
    <div
      class="personalMainRight"
      :style="{
        width: currentInfo && currentInfo.roleCode === 'ASSISTANT' ? '100%' : isCollapse ? 'calc(100% - 85px)' : 'calc(100% - 190px)',
      }"
    >
    
      <router-view
        class="personalMainRightContainter fullBox"
        :key="$route.fullPath"
        :style="{
          minWidth: isCollapse ? '1051px' : '1150px',
          height:
            $route.path ==
              '/personal/serviceHome/writeProcedure/lookFqCeryificate' ||
            $route.path ==
              '/personal/serviceHome/writeProcedure/fqNotarialDetail' ||
            $route.path == '/personal/serviceHome/fqCertificate' ||
            $route.path == '/personal/serviceHome/urgeCertificate' ||
            $route.path == '/personal/home' || 
            $route.path == '/personal/sign/detail'
              ? 'auto'
              : '100%',
        }"
      ></router-view>
    </div>
    <Loading v-if="$store.state.isLoading"></Loading>
    <LoadingText v-if="$store.state.isLoadingText"></LoadingText>
    <LoginGuidance
      v-if="isShowGuide"
      @closeGuide="closeGuide"
      @showIndex="showGuide"
    ></LoginGuidance>
  </div>
</template>

<script>
import Empty from './Empty.vue';
import Loading from '../common/Loading.vue';
import LoadingText from '../common/LoadingText.vue';
import LoginGuidance from '../common/LoginGuidance.vue';
import PersonalHead from './../common/PersonalHead.vue';
import BaseApi from '@lib/baseApi.js';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    Empty,
    PersonalHead,
    Loading,
    LoadingText,
    LoginGuidance,
  },
  data() {
    return {
      isCollapse: false,
      defaultOpenedsArray: ['1', '2', '3', '5', '6'],
      imgIndex: 0,
      currentUrl: '',
      notarList: [
        '/personal/serviceHome',
        '/personal/serviceHome/fqCertificate',
        '/personal/serviceHome/lawyerEvidence',
        '/personal/serviceHome/writeProcedure',
        '/personal/serviceHome/writeProcedure/fqNotarialDetail',
        '/personal/serviceHome/writeProcedure/fqDataDetail',
        '/personal/serviceHome/writeProcedure/fqNotarialDetail',
        '/personal/serviceHome/writeProcedure/lookFqCeryificate',
        '/personal/serviceHome/urgeCertificateShare',
      ],
      result: {},
      realNameq: false,
      notaryBusinessId: '', // 赋强公证类型 贷款赋强公证：2，贷款强制公证：3，调解赋强公证：7，调解强执公证：8
      showIndex: 0, //当前操作引导项
      isShowGuide: false, //是否显示操作引导
    };
  },
  mounted() {
    this.currentUrl = this.$route.path;
    this.notaryBusinessId = this.$route.query.notaryBusinessId || '';
    this.$nex;
  },
  created() {
    this.statusFn();
    this.loginCheck();
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    ...mapState(['currentInfo']),
  },
  watch: {
    '$route.path'(newValue, oldVale) {
      if (newValue !== oldVale) {
        this.currentUrl = newValue;
        this.notaryBusinessId = this.$route.query.notaryBusinessId || '';
      }
    },
    currentInfo() {
      if (this.currentInfo.roleCode === 'ASSISTANT') {
        this.$router.replace('/personal/businessManagement/outsideAgencies');
      }
      this.statusFn();
    },
    '$store.state.isHomeGuideFn'(data) {
      if (data) {
        this.isShowLoginGuide();
      }
    },
  },
  methods: {
    //操作引导
    showGuide(data) {
      this.showIndex = data;
    },
    closeGuide(data) {
      this.isShowGuide = data;
      this.$store.commit('showHomeGuide', data);
    },
    //校验是否第一次登录
    loginCheck() {
      let isRead = JSON.parse(sessionStorage.getItem('isRead'));
      this.isShowGuide = isRead;
      if (this.isShowGuide) {
        this.showIndex = 1;
      }
    },
    //是否显示操作引导
    isShowLoginGuide() {
      this.isShowGuide = true;
      this.showIndex = 1;
      this.defaultOpenedsArray = []; //收起子菜单
    },
    handelCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    handleSelect(key, keyPath) {},
    statusFn() {
      BaseApi.createRpcToken('/user/v2/getUserInfo').then(
        (data) => {
          let userArr = [...[data.datas.person], ...data.datas.enterpriseList];
          let curInfo = userArr.filter(
            (item) => item.userId == data.datas.currentUserId,
          );
          this.result = curInfo[0];
          this.resultData = data.datas;
          this.step = this.result.authenticationStatus;
          // if( this.result.authenticationStatus==2 ||
          //     this.result.authenticationStatus==1 ||
          //     this.result.authenticationStatus==3 ||
          //     this.result.authenticationStatus==5
          // ){
          //   this.allNot=false;
          if (this.result.realNameType == '1') {
            // this.realNameg=true;
            this.realNameq = false;
            if (this.$route.path == '/personal/users/enterpriseSupplement') {
              this.$router.push('/personal/users/home');
            }
          } else {
            //法人未实名的状态显示
            if (
              this.result.authenticationStatus == 2 &&
              (this.result.legalPersonStatus == 0 ||
                this.result.legalPersonStatus == 3 ||
                this.result.legalPersonStatus == 1 ||
                this.result.legalPersonStatus == 5)
            ) {
              this.realNameq = true;
            }
          }
          // }else{
          //   this.allNot=true;
          //   this.realNameg=false;
          //   this.realNameq=false;
          // }
        },
        () => {},
      );
    },
    routerPush(url){
     this.$router.push(url)
    },
    toInitiationBatch() {
      sessionStorage.setItem('batchUploadVisible', 1);
      this.$router.push('/initiation/batch');
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scope>
.father {
  padding: 0 20px;
  color: #505050;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.el-submenu__title {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.el-submenu {
  .is-active {

    .img02 {
      display: inline-block !important;
    }

    .img01 {
      display: none !important;
    }

    span {
      display: inline-block;
    }
  }
}

.activeItem {
  // color: #fff !important;
}

.activeColor {
  // color: #c8c8c8;
  // background: #d81212 ;

  .img02 {
    display: inline-block !important;
  }

  .img01 {
    display: none !important;
  }

  span {
    display: inline-block;
  }
}

.is-opened {
  // color: #CE1B17;
  background: #ffffff !important;

  .father {
    .img02 {
      display: none !important;
    }

    .img01 {
      display: inline-block !important;
    }
  }
}

//兼容ie浏览器
.el-submenu__title:focus,
.el-submenu__title:hover {
  background: none;
  //  background: #2d313a;
}
.el-menu-item:focus, .el-menu-item:hover {
  background-color: #fff1f0;
  color: #CE1B17;
}
.el-menu-item-group > ul {
  padding: 0;
  background: #ffffff;
  color: #505050;
}

.el-menu-item-group__title {
  display: none;
}

.el-submenu .el-menu-item {
  min-width: 180px !important;
}

.el-menu {
  background: #ffffff;
}

.el-menu-item {
  color: #c8c8c8;
}

.el-submenu__title {
  color: #c8c8c8;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  // height: calc(100% - 40px);
  height: 100%;
  overflow-y: auto;
  background-color: #ffffff;
}

.el-menu-vertical-demo:not(.el-menu--collapse)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse)::-moz-scrollbar {
  width: 8px;
  height: 8px;
  display: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse)::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}

.el-menu-vertical-demo:not(.el-menu--collapse):hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}

.el-menu-vertical-demo:not(.el-menu--collapse)::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: white;
}

.el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
  position: relative;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  color: #505050;
}



.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
  padding: 0 45px;
  min-width: 200px;
}

.el-submenu__title:hover {
  // background-color: #333744;
  color: #CE1B17;
}

.el-menu-item {
  .img02 {
    display: none;
    margin-right: 10px;
  }

  .img01 {
    display: inline-block;
    margin-right: 10px;
  }
}

.el-menu {
  border-right: none;
}

html,
body {
  width: 100%;
  height: 100%;
}

#app {
  height: 100%;
}

.personalMain {
  height: 100%;
  overflow: hidden;

  .personalMainHead {
    width: 100%;
    height: 60px;
    background: #2d313a;
  }

  .personalMainLeft {
    height: calc(100% - 50px);
    // background: #2d313a;
    float: left;
    // overflow-y: auto;
    background-color: #EAEDF1;
    padding: 5px 0 0 0;
    .bg {
      height: 40px;
      line-height: 40px;
      background: #4a5064;
      // border-right: solid 1px #e6e6e6;
    }

    .img02 {
      display: none;
    }

    .img01 {
      display: inline-block;
    }

    .icon {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 10px;
      margin-left: 6px;
      text-align: center;
    }
  }

  .personalMainRight {
    width: 100%;
    height: calc(100% - 70px);
    padding: 5px;
    float: left;
    overflow: auto;
    background-color: #eaedf1;
    border-radius: 3px;

    .personalMainRightContainter {
      background-color: #ffffff;
      width: 100%;
      // height: auto;
      min-height: 100%;
      border-radius: 3px;
    }
  }
}

.el-submenu {
  background: #ffffff;
}

.el-submenu__icon-arrow {
  margin-top: -3px;
}

.el-submenu .el-submenu__icon-arrow::before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-width: 5px 5px 5px 0;
  border-style: solid;
  border-color: transparent #c8c8c8 transparent transparent;
}

// .el-submenu.is-opened>.el-submenu__title .activeColor  .el-submenu__icon-arrow::before{
//     content:'';
//     display:block;
//     width:0;
//     height:0;
//     border-width:5px 5px 5px 0;
//     border-style:solid;
//     border-color: transparent #fff transparent transparent;
//   }
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow::before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-width: 5px 5px 5px 0;
  border-style: solid;
  // border-color: transparent #CE1B17 transparent transparent !important;
}

.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotateZ(-90deg);
}

.el-menu-item.is-active {
  color: #CE1B17;
  background-color: #ffffff !important;
}

.no-active {
  color: #505050 !important;
}

.menubar .el-submenu .is-active {
  color: #fff !important;
}

.is-opened {
  span {
    // color: #CE1B17;
  }
}

.paddingLefts {
  padding-left: 50px !important;
}

.guide {
  position: relative;
  z-index: 999;
}

.el-submenu.is-disabled .el-submenu__title {
  opacity: 1 !important;
  cursor: auto;
}

</style>
